import React, { Fragment } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import './BasicHeroWithOutButton.scss';
import './BasicHeroWithOutButtonCC.scss';

const BasicHeroWithOutButton = (props) => {
  const { opts = {} } = props;
  const {
    collectionLink,
    cornerCaption,
    heading,
    subHeading,
    heroMedia = {},
    heroMediaMobile = {},
    eventLogo = {},
    eventLogoMobile = {},
    id,
    isHeroModuleWithoutButtonCC,
    isHeroModuleWithoutButton
  } = opts;
  const wrapperClass = classNames({
    etchHeroCC: isHeroModuleWithoutButtonCC,
    etchHero: isHeroModuleWithoutButton
  });
  return (
    <div className={wrapperClass} id={id}>
      <picture className={`${wrapperClass}__media`}>
        <source media="(min-width: 640px)" srcSet={heroMedia.src} />
        {heroMediaMobile.src
          && <source media="(min-width: 0px)" srcSet={heroMediaMobile.src} />}
        {!heroMediaMobile.src
          && <source media="(min-width: 0px)" srcSet={heroMedia.src} />}
        <img className={`stretchy ${wrapperClass}__main`} src={heroMedia.src} alt={heroMedia.alt} />
      </picture>
      <div className={`${wrapperClass}__info u__text-shadow--none`}>
        {eventLogo.src
          && (
            <div className={`${wrapperClass}__logo`}>
              <Image src={eventLogo.src} className={`${wrapperClass}__eventLogo`} alt={eventLogo.alt} />
            </div>
          )}
        {eventLogoMobile.src
          && (
            <div className={`${wrapperClass}__mobilelogo`}>
              <Image src={eventLogoMobile.src} className={`${wrapperClass}__eventLogoMobile`} alt={eventLogoMobile.alt} />
            </div>
          )}

        <h2 className={`${wrapperClass}__heading u__display-font--black u__jumbo`}>
          {heading}
        </h2>
        {subHeading
          && <h3 className={`${wrapperClass}__subHeading u__large`}>{subHeading}</h3>}
      </div>
      <div className={`${wrapperClass}__corner`}>
        {collectionLink
          && (
            <a className={`${wrapperClass}__corner__caption`} href={collectionLink}>
              {cornerCaption}
            </a>
          )}
        {!collectionLink
          && <p className={`${wrapperClass}__corner__caption`}>{cornerCaption}</p>}
      </div>
    </div>
  );
};

BasicHeroWithOutButton.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.string,
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.string,
    cornerCaption: PropTypes.string,
    type: PropTypes.string,
    isHeroModuleWithoutButtonCC: PropTypes.bool,
    isHeroModuleWithoutButton: PropTypes.bool
  })
};
BasicHeroWithOutButton.defaultProps = {
  opts: {
    isHeroModuleWithoutButtonCC: false,
    isHeroModuleWithoutButton: false
  }
};

export default BasicHeroWithOutButton;
